"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const copyAxiosInterceptorsAndHeaders = (sourceInstance, targetInstance) => {
    sourceInstance.interceptors.request.forEach((interceptor) => {
        targetInstance.interceptors.request.use(interceptor.fulfilled, interceptor.rejected);
    });
    sourceInstance.interceptors.response.forEach((interceptor) => {
        targetInstance.interceptors.response.use(interceptor.fulfilled, interceptor.rejected);
    });
    targetInstance.defaults.headers = sourceInstance.defaults.headers;
};
exports.default = copyAxiosInterceptorsAndHeaders;
//# sourceMappingURL=copyAxiosInterceptorsAndHeaders.js.map